var app = window.app || {};

(function ($, _DateSelectorTitle, _DateSelectorYear, _DateSelectorMonth, _DateSelectorDay) {

    var classes = {
        selectedCell: 'date-selector-cell__selected',
        hidden: 'hidden-block'
    };

    var eventHandler = $({});

    var _eventTimeout;

    var _currentDate;

    var _events = {
        ageRestrictedOpen: function () {
            _eventTimeout && clearTimeout(_eventTimeout);
            if (window.app && app.event && app.event.ageRestrictedOpen) {
                _eventTimeout = setTimeout(app.event.ageRestrictedOpen, 100);
            }
        },
        ageRestrictedNotValid: function () {
            _eventTimeout && clearTimeout(_eventTimeout);
            if (window.app && app.event && app.event.ageRestrictedNotValid) {
                _eventTimeout = setTimeout(app.event.ageRestrictedNotValid, 100);
            }
        },
        ageRestrictedValid: function () {
            _eventTimeout && clearTimeout(_eventTimeout);
            if (window.app && app.event && app.event.ageRestrictedValid) {
                _eventTimeout = setTimeout(app.event.ageRestrictedValid, 100);
            }
        }
    };

    app.DateSelector = (function ($view) {
        var $el;
        var $container;
        var $input;
        var _openDatePicker = false;
        var _eventHandler = $({});
        var isOpened = false;
        var _func;

        var currentYear = new Date().getFullYear();
        var minYear = currentYear - 159;

        var selectedDate = {
            day: null,
            month: null,
            year: null,
            getDate: function () {
                if (this.year >= minYear && this.year <= currentYear) {
                    if (this.day !== null && this.month !== null && this.year !== null && this.day !== undefined && this.month !== null && this.year !== null) {
                        return new Date(this.year, this.month, this.day);
                    }
                }
                return null;
            }
        };

        var _dsEventHandler = DateSelectorEvents();

        var _title = _DateSelectorTitle(eventHandler, _dsEventHandler);
        var _year = _DateSelectorYear(classes, eventHandler, _dsEventHandler);
        var _month = _DateSelectorMonth(classes, eventHandler, _dsEventHandler);
        var _day = _DateSelectorDay(classes, eventHandler, _dsEventHandler);

        var _dateInput = null;

        var _yearPage = 1;


        var _setInputDate = function () {
            var month = selectedDate.month === null ? null : selectedDate.month + 1;
            _dateInput.setDate({
                day: selectedDate.day,
                month: month,
                year: selectedDate.year
            });
        }

        var _updateDate = function (date) {
            var d = _day.setDay(date.day);
            var m = _month.setMonth(date.month);
            var y = _year.setYear(date.year);
            _title.setDay(d);
            _title.setMonth(m.value);
            _title.setYear(y);
            selectedDate.day = d;
            selectedDate.month = m.num;
            selectedDate.year = y;
            _dateInput.setDate(date);
        } 

        var _initDateInput = function ($el, minYearOffset, ageOffset) {

            _dateInput = DateInput(true, minYearOffset, ageOffset);
            var result = _dateInput.init($el);
            if (result) {
                _dateInput.onChange(function (isValid, _sd, date) {
                    _updateDate(date);
                    _func && _func(isValid, _sd, date);
                });
                _dateInput.onChangeSelected(_dsEventHandler.displayDays, _dsEventHandler.displayMonths, _dsEventHandler.displayYears);
                _dateInput.onClose(function () {
                    _close();
                });
            }
            return result;
        }


        var _onChangeYear = function (e, value) {
            _title.setYear(value);
            selectedDate.year = value;
            _setInputDate();
            _day.updateDay(selectedDate.month, selectedDate.year);
            //_dsEventHandler.displayMonths();
            _setDate();
        }

        var _onChangeMonth = function (e, month) {
            _title.setMonth(month.value);
            selectedDate.month = month.num;
            _setInputDate();
            _day.updateDay(selectedDate.month, selectedDate.year);
            _dsEventHandler.displayYears();
        }

        var _onChangeDay = function (e, value) {
            _title.setDay(value);
            selectedDate.day = value;
            _setInputDate();
            _dsEventHandler.displayMonths();
            //_setDate();
        }

        var _setDate = function (silent) {
            var date = selectedDate.getDate();
            date && $input.val(dateFormat(date, "dd/mm/yyyy"));
            date && !silent && _close();
        };

        var _initTitle = function () {
            _title.init();
            _title.appendTo($container);
            _title.onDisplayYears(_dsEventHandler.displayYears);
            _title.onDisplayMonthes(_dsEventHandler.displayMonths);
            _title.onDisplayDays(_dsEventHandler.displayDays);
        };

        var _initYears = function () {
            _year.init();
            _year.appendTo($container);
            _year.onChange(_onChangeYear);

            _title.onClickPrev(function () {
                _yearPage = _year.setPage(_yearPage + 1);
            });

            _title.onClickNext(function () {
                _yearPage = _year.setPage(_yearPage - 1);
            });
        };

        var _initMonth = function () {
            _month.init();
            _month.appendTo($container);
            _month.onChange(_onChangeMonth);
        };

        var _initDay = function () {
            _day.init(selectedDate.month, selectedDate.year);
            _day.appendTo($container);
            _day.onChange(_onChangeDay);
        };

        var _open = function () {
            if (!isOpened) {
                isOpened = true;
                $container.removeClass(classes.hidden);
                _dsEventHandler.displayDays();
                _events.ageRestrictedOpen();
            }
        };

        var _close = function () {
            if (isOpened) {
                isOpened = false;
                var date = selectedDate.getDate();
                $container.addClass(classes.hidden);
                date && _eventHandler.trigger('changeDate');
            }
        };

        var _subscribe = function (_openDatePicker, isReadOnly) {
            if (_openDatePicker || isReadOnly) {
                $el.find('@openBtn').addClass(classes.hidden);
                $el.find('@dateSelectorInput').on('focus', function () {
                    _open();
                });
            }

            if (!_openDatePicker)
            {
                $el.find('@openBtn').removeClass(classes.hidden);
                $el.find('@openBtn').on('click', function () {
                    if (isOpened) {
                        _close();
                    } else {
                        _open();
                    }
                });
            }

            $(document).click(function (event) {
                $target = $(event.target);
                if (!_openDatePicker && !isReadOnly && $target.closest('@dateSelectorInput').length) {
                    _close();
                }
                if (!$target.closest('@dateSelectorInput').length
                    && !$target.closest('@calendar').length
                    && !$target.closest('@dayCell').length
                    && !$target.closest('@openBtn').length) {
                    _close();
                }
            });

        };

        var _validate = function () {
            var currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59);
            var controlTime = currentDate.setYear(currentDate.getFullYear() - 18);
            var date = selectedDate.getDate();
            var isValid = date && date.getTime() < controlTime;
            $input.toggleClass('invalid', !isValid);
            isValid ? _events.ageRestrictedValid() : _events.ageRestrictedNotValid();
            return isValid;
        }

        return {
            init: function (isAgeRestricted, openDatePicker) {
                _openDatePicker = !!openDatePicker;
                if (isAgeRestricted) {
                    if (!$el) {
                        $el = $.tmpl('date-picker');
                        $container = $el.find('@calendar');
                        $input = $el.find('@dateSelectorInput');
                        $(function () {
                            $view.append($el);
                            _initTitle();
                            _initYears();
                            _initMonth();
                            _initDay();
                            var result = _initDateInput($input, 159, 18);
                            _subscribe(_openDatePicker, !result);
                        });

                    }
                }
            },

            onChange: function (func) {    
                _eventHandler.on('changeDate', function (e) {
                    var isValid = _validate();
                    var date = selectedDate.getDate();
                    if (date !== undefined && date !== null && (!_currentDate || _currentDate.getTime() !== date.getTime())) {
                        _currentDate = date;
                        func(isValid, date, { day: selectedDate.day, month: selectedDate.month + 1, year: selectedDate.year });
                    }
                });
                _func = func;
            },
            setDate: function (d) {
                _updateDate({ day: d.day, month: d.month, year: d.year });
                _dateInput.setDate(d);
            }
        }

    });

})(jQuery, DateSelectorTitle, DateSelectorYear, DateSelectorMonth, DateSelectorDay);